import { render } from "./Cocktail.vue?vue&type=template&id=662d8f0e"
import script from "./Cocktail.vue?vue&type=script&scoped=true&lang=js"
export * from "./Cocktail.vue?vue&type=script&scoped=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__